<template>
  <div>
    <el-card>
      <div style="margin-bottom: 20px">
        <el-button
          type="primary"
          icon="el-icon-plus"
          size="mini"
          @click="handelAdd"
          >添加</el-button
        >
      </div>
      <el-table stripe border :data="list">
        <el-table-column
          type="index"
          label="序号"
          width="80"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="username"
          label="管理员账号"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="create_time"
          label="创建时间"
          align="center"
        ></el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="primary"
              icon="el-icon-edit"
              size="mini"
              @click="handelEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              icon="el-icon-delete"
              size="mini"
              @click="deleteGoods(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[5, 10, 20, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handelSizeChange"
        @current-change="handelPage"
      >
      </el-pagination>
    </el-card>
    <el-dialog
      :title="type == 1 ? '新增管理员' : '编辑管理员'"
      :visible.sync="dialogFormVisible"
      width="800px"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="120px">
        <el-form-item label="管理员账号">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="密码">
          <el-input v-model="form.pwd"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAdminData, editAdminData, deleteAdminData } from "@/api";
import uploadImg from "@/components/upload-img/index.vue";
export default {
  name: "adminList",
  components: {
    uploadImg,
  },
  data() {
    return {
      page: 1,
      pageSize: 10,
      total: 0,
      list: [],
      dialogFormVisible: false,
      type: 1, //1添加 2编辑
      form: {},
    };
  },
  mounted() {
    this.getAdminList();
  },
  methods: {
    submit() {
      if (!this.form.username) {
        this.$message.error("账号不能为空");
        return;
      }
      if (!this.form.pwd) {
        this.$message.error("密码不能为空");
        return;
      }
      let formData = new FormData();
      formData.append("username", this.form.username);
      formData.append("pwd", this.form.pwd);
      formData.append("type", this.type);
      if (this.type == 2) {
        formData.append("id", this.form.id);
      }
      editAdminData(formData).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.dialogFormVisible = false;
          this.getAdminList();
        }
      });
    },
    handelEdit({ id, username }) {
      this.form = { id, username };
      this.type = 2;
      this.dialogFormVisible = true;
    },
    handelAdd() {
      this.form = {};
      this.type = 1;
      this.dialogFormVisible = true;
    },
    deleteGoods({ id, username }) {
      this.$confirm(
        `此操作将永久删除管理员【${username}】, 是否继续?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(() => {
          let formData = new FormData();
          formData.append("id", id);
          deleteAdminData(formData).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功!",
              });
              this.getAdminList();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    getAdminList() {
      let formData = new FormData();
      formData.append("page", this.page);
      formData.append("size", this.pageSize);
      getAdminData(formData).then((res) => {
        this.list = res.data;
        this.total = res.count;
      });
    },
    handelPage(val) {
      this.page = val;
      this.getAdminList();
    },
    handelSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getAdminList();
    },
  },
};
</script>

<style></style>
